// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // apiBaseURL: 'http://localhost:5000/api/v2',
  // apiBaseURL: 'https://mapcloud-portal-staging.thinkwhere-labs.com/api/v2',
  // apiBaseURL: 'https://eurogeographics-staging.thinkwhere-labs.com/api/v2',
  // apiBaseURL: "https://www.euro-geo-opendata.eu/api/v2",
  mapBaseURL: 'https://staging.mapsforeurope.org',
  apiBaseURL: 'https://staging.mapsforeurope.org/api/v2',
  thinkWhereToken: 'InRoaW5rd2hlcmVfYWRtaW4i.D3zwww.nJEOrHXIZPnrz2CjBg5aRoYIAZw',
  elsToken: 'InRoaW5rd2hlcmVfYWRtaW4i.D3zwww.nJEOrHXIZPnrz2CjBg5aRoYIAZw',
  euroGlobalMapToken: 'ImV1cm9nZW9ncmFwaGljc19iYXNlbWFwIg.D63Vwg.jTVqAlNTKOe3EGcKzMna-HqBvD0',
};
